'use client'

import dynamic from 'next/dynamic'
import { Suspense } from 'react'

import type { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical'

import type { Form } from '@/payload-types'

import type { MapLocation } from './MapBlock'

type MapBlockClientProps = {
  body?: SerializedEditorState | null
  contactForm?: Form | string | null
  /** Full-width map only — no sidebar list / filters. */
  layout?: 'default' | 'fullWidth'
  showHeader?: boolean
  title?: string
  mapIntro?: {
    body?: SerializedEditorState | null
    headingStyle?: null | string
    title?: string
  } | null
  locations: MapLocation[]
}

const MapBlockNoSSR = dynamic(() => import('./MapBlock').then((mod) => mod.MapBlock), {
  ssr: false,
})

export function MapBlockClient({
  body,
  contactForm,
  layout = 'default',
  showHeader,
  title,
  mapIntro,
  locations,
}: MapBlockClientProps) {
  return (
    <Suspense fallback={null}>
      <MapBlockNoSSR
        body={body}
        contactForm={contactForm}
        layout={layout}
        showHeader={showHeader}
        mapIntro={mapIntro}
        title={title}
        locations={locations}
      />
    </Suspense>
  )
}
